import { Box } from "@mui/material"

type GraphIndicatorsProps = {
  showModifiedIndicator: boolean
  showUserGraphIndicator: boolean
  isModified: boolean
}

const GraphIndicators = (props: GraphIndicatorsProps) => {
  return (
    <>
      {props.showModifiedIndicator && (
        <Box
          sx={{
            display: "inline",
            float: "right",
            fontWeight: "bold",
            fontSize: "14px",
            mr: 0,
            mt: 0,
            border: "2px solid",
            borderRadius: "8px",
            paddingX: "4px",
            paddingY: "4px",
            color: props.isModified ? "#FF9800" : "#648FFF",
          }}
        >
          {props.isModified ? "MODIFIED" : "UNMODIFIED"}
        </Box>
      )}
      {props.showUserGraphIndicator && (
        <Box
          sx={{
            display: "inline",
            float: "right",
            fontWeight: "bold",
            fontSize: "14px",
            mr: 0,
            mt: 0,
            mb: 0,
            border: "2px solid",
            borderRadius: "8px",
            paddingX: "4px",
            paddingY: "4px",
            color: "#DC267F",
          }}
        >
          USER-PARAMETRISED GRAPH
        </Box>
      )}
    </>
  )
}

export default GraphIndicators
